import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { Table } from "react-bootstrap";

const ItemPpsComp = (props) => {
  // console.log(props.ppsitem);
  return (
    <Table striped bordered hover>
      <thead className="bg-primary border-1 text-center text-white">
        <tr>
          <th width="100px">
            <b>Standar</b>
          </th>
          <th>
            <b>Elemen Penilaian</b>
          </th>
          <th>
            <b>Fakta Analisis</b>
          </th>
          <th>
            <b>Rekomendasi</b>
          </th>
        </tr>
      </thead>
      <tbody className="border-1">
        <tr>
          <td className="text-center">
            {
              props.ppsitem?.variables_accreditation?.elements_accreditation
                ?.Nomor
            }
          </td>
          <td>
            {props.ppsitem?.variables_accreditation?.Abjad}.{" "}
            {props.ppsitem?.variables_accreditation?.Deskripsi}
          </td>
          <td>{props.ppsitem?.faktaAnalisisLipa}</td>
          <td>{props.ppsitem?.rekomendasiLipa}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ItemPpsComp;
